import React, { Component } from 'react';
import ProductVariationContext from './ProductVariationContext';
class ProductVariationProvider extends Component {
    constructor(props) {
        super(props);
        this.peekVariant = (selectedOptions) => {
            const { product } = this.props;
            const values = product.variants.options.map(({ name }) => selectedOptions[name]);
            return product.variants.values.find((variation) => {
                return variation.values
                    ? values.join(',') === variation.values.join(',')
                    : false;
            });
        };
        this.getSelectOptionState = (optionName, value, selectedOptions) => {
            let newSelectedOptions = Object.assign({}, selectedOptions, { [optionName]: value });
            const selectedVariation = this.peekVariant(newSelectedOptions);
            // If all options are selected but there is no valid variation only choose the selected option and clear the others.
            const validSelectedOptions = selectedVariation ||
                this.state.options.length !== Object.keys(newSelectedOptions).length;
            if (!validSelectedOptions) {
                newSelectedOptions = {
                    [optionName]: value
                };
            }
            const hasMissingOption = this.getMissingOptions(newSelectedOptions).length !== 0;
            const newState = {
                selectedOptions: newSelectedOptions,
                missingOption: null,
                hasMissingOption,
                selectedVariation
            };
            return newState;
        };
        this.selectOption = (optionName, value) => {
            const { selectedOptions } = this.state;
            this.setState(this.getSelectOptionState(optionName, value, selectedOptions));
        };
        this.getStockStatus = (optionName, value) => {
            const { selectedOptions } = this.state;
            const peekedVariant = this.peekVariant(Object.assign({}, selectedOptions, { [optionName]: value }));
            return peekedVariant && peekedVariant.stockStatus;
        };
        this.isDisabled = (optionName, value) => {
            let newSelectedOptions = Object.assign({}, this.state.selectedOptions, { [optionName]: value });
            // If the number of options is not equal to the selected options then it should always be valid
            // If it is equal, we want to make sure there is a valid variant for those options
            const validSelectedOptions = this.state.options.length !== Object.keys(newSelectedOptions).length ||
                this.peekVariant(newSelectedOptions);
            // Finally, even if there is no valid variant, we never want the first row of options to be disabled
            return !(this.state.options[0].name === optionName || validSelectedOptions);
        };
        this.getSelectableOptionItems = (optionName) => {
            const { selectedOptions, options } = this.state;
            const picker = options.find(option => option.name === optionName);
            return (picker &&
                picker.values.map((value) => {
                    const selected = selectedOptions[optionName] === value;
                    const variant = this.peekVariant(Object.assign({}, this.state.selectedOptions, { [optionName]: value }));
                    const disabled = this.isDisabled(optionName, value);
                    return {
                        props: {
                            disabled,
                            selected,
                            onClick: () => {
                                this.selectOption(optionName, value);
                            }
                        },
                        value,
                        variant
                    };
                }));
        };
        this.getMissingOption = (selectedOptions) => {
            return this.props.product.variants.options.find(option => {
                return !Object.keys(selectedOptions).includes(option.name);
            });
        };
        this.getMissingOptions = (selectedOptions) => {
            return this.props.product.variants.options.filter(option => {
                return !Object.keys(selectedOptions).includes(option.name);
            });
        };
        this.setMissingOption = () => {
            const missingOption = this.getMissingOption(this.state.selectedOptions);
            const missingOptions = this.getMissingOptions(this.state.selectedOptions);
            // We provide the missing option purely for backwards compatibility where before we were not return an array of options
            this.setState({ missingOption, missingOptions, hasMissingOption: true });
            return missingOptions;
        };
        const { product } = props;
        this.state = {
            quantity: 1,
            selectedVariation: null,
            selectedOptions: {},
            options: product.variants.options,
            getSelectableOptionItems: this.getSelectableOptionItems,
            setMissingOption: this.setMissingOption,
            missingOption: null,
            missingOptions: [],
            hasMissingOption: product.variants.options.length > 0
        };
        let partialState = {
            selectedOptions: {}
        };
        product.variants.options.forEach(option => {
            if (option.values.length === 1) {
                partialState = this.getSelectOptionState(option.name, option.values[0], partialState.selectedOptions);
            }
        });
        this.state = Object.assign({}, this.state, partialState);
    }
    componentDidUpdate(prevProps) {
        const { product } = this.props;
        if (prevProps.product.id !== product.id) {
            this.setState({
                options: product.variants.options
            });
            product.variants.options.forEach(option => {
                if (option.values.length === 1) {
                    this.selectOption(option.name, option.values[0]);
                }
            });
        }
    }
    render() {
        return (React.createElement(ProductVariationContext.Provider, { value: Object.assign({}, this.state, { product: this.props.product }) }, this.props.children));
    }
}
export default ProductVariationProvider;
//# sourceMappingURL=ProductVariationProvider.js.map